import React from "react";
const autobind = require("class-autobind").default;
import shortid from "shortid";
import { Checkbox } from "../../form/checkbox/index";
import { FormTreeSelect } from "../../form/tree";
import styled from "styled-components";
const SalesTaxCard = styled.div `
	display: flex;
	padding: 12px;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 8px;
	align-self: stretch;
	border-radius: 4px;
	border: 1px dashed var(--Secondary-Light-Grey-1, #DFDFDF);
	background: var(--Primary-Light-Alabaster-1, #F5F5F5);
	margin-bottom: 16px;
`;
const EligibleItemsContainer = styled.div `
display: flex;
flex-direction: column;
justify-content: center;
align-items: flex-start;
align-self: stretch;

& div.no-border-v2 {
	border: none!important;
}

& [class*="CheckboxLabel"] {
	display: flex;
	align-items: center;
	
	&::before {
		vertical-align: middle;
		flex: 0 0 18px;
    	top: 0px;
	}

	& span {
		white-space: pre-wrap;
		word-break: break-all;
	}
}
`;
const SettingsFormGroup = styled.div `
display: flex;
padding: 16px;
flex-direction: column;
align-items: flex-start;
gap: 24px;
width: 100%;
& p {
    color: var(--Secondary-Smokey-Grey-1, #6B7270);
font-family: Inter;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 150% */
}

@media (min-width: 768px) {
	flex-direction: row;
	flex-wrap: wrap;
}
`;
const SettingsFormGroupInput = styled.div `
display: flex;
width: 100%;
flex-direction: column;
align-items: flex-start;
gap: 4px;
@media (min-width: 768px) {
	flex: 1;

	&.flex-full {
		flex: 0 0 100%;
	}
}
`;
const SettingsFormLabelContainer = styled.div `
display: flex;
align-items: center;
gap: 8px;
align-self: stretch;
`;
const SettingsFormLabelLeftContainer = styled.div `
display: flex;
align-items: flex-start;
gap: 8px;
flex: 1 0 0;
color: var(--Secondary-Dark-Grey-1, #4B4F5E);
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 24px; /* 171.429% */

& label[class*="CheckboxLabel"] {
	display: flex;
}
`;
const SettingsFormLabelRightContainer = styled.div `
display: flex;
justify-content: flex-end;
align-items: center;
gap: 8px;
flex: 0 0 20px;
`;
const SettingsFormInputContainer = styled.div `
display: flex;
padding: 12px;
align-items: center;
gap: 8px;
align-self: stretch;
border-radius: 4px;
border: 1px solid var(--Secondary-Light-Grey-1, #DFDFDF);
background: var(--Neutral-White, #FEFEFE);

& input, & select, & textarea {
    color: var(--Secondary-Dark-Grey-1, #4B4F5E);
    pointer-events: auto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    border: none;
    width: 100%;
    &:focus-visible {
        outline: unset;
    }
}
&.disabled,&:disabled {
    background: var(--Secondary-Light-Grey-1, #DFDFDF);
    & input {
        background: var(--Secondary-Light-Grey-1, #DFDFDF);
    }
}

& div[class^="datepickerinput"] {
    width: 100%;
    & .dropdown {
        width: 100%;
    }
}

& div[class^="selectadv__Wrapper"] {
    border: none;
    padding: 0px;
    & div[class^="selectadv__InputIcon"] {
        border-left: none;
        color: #4B4F5E;
        justify-content: end;
    }

    & div[class^="inputtags__Tag"] {
        background: #dfdfdf;
        color: var(--Secondary-Dark-Grey-1, #4B4F5E);
font-family: Inter;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 150% */
    }
}

& div[class^="inputtags__Wrapper"] {
    border: none;
    padding: 0px;
}
`;
const SalesTaxesAddButton = styled.button `
display: flex;
padding: 8px 16px;
align-items: center;
gap: 4px;
border-radius: 4px;
border: 1px solid var(--Primary-Red-Orange-1, #FB2F2F);
background: transparent;
color: var(--Primary-Red-Orange-1, #FB2F2F);
text-align: center;
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 16px; /* 114.286% */
cursor: pointer;
`;
export const TrashIcon = () => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
    React.createElement("path", { d: "M7 21C6.45 21 5.979 20.804 5.587 20.412C5.195 20.02 4.99933 19.5493 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.804 20.021 18.412 20.413C18.02 20.805 17.5493 21.0007 17 21H7ZM17 6H7V19H17V6ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z", fill: "#4B4F5E" })));
const IconPlusRed = ({ width = 16, height = 16 }) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 16 16", fill: "none" },
        React.createElement("mask", { id: "mask0_663_15873", style: { maskType: 'alpha' }, maskUnits: "userSpaceOnUse", x: "0", y: "0", width: width, height: height },
            React.createElement("rect", { width: width, height: height, fill: "#D9D9D9" })),
        React.createElement("g", { mask: "url(#mask0_663_15873)" },
            React.createElement("path", { d: "M7.33325 8.66671H3.33325V7.33337H7.33325V3.33337H8.66658V7.33337H12.6666V8.66671H8.66658V12.6667H7.33325V8.66671Z", fill: "#FB2F2F" }))));
};
export class FieldTaxesv2 extends React.Component {
    constructor(props) {
        super(props);
        autobind(this);
    }
    componentDidMount() {
        this.props.setAdd(this.add);
    }
    nodeGetDeepestChildrenValues = (node) => {
        let children = [];
        if (node.children) {
            for (const child of node.children) {
                if (child.children) {
                    children = [...children, ...this.nodeGetDeepestChildrenValues(child)];
                }
                else {
                    children.push(child.value);
                }
            }
        }
        return children;
    };
    gatherAllChildrenNodes = () => {
        let children = [];
        this.props.treeData.forEach((node) => {
            children = children.concat(this.nodeGetDeepestChildrenValues(node));
        });
        return children;
    };
    add = () => {
        const children = this.gatherAllChildrenNodes();
        const taxes = this.props.taxes ? [...this.props.taxes] : [];
        taxes.push({
            _id: shortid.generate(),
            name: "TAX",
            rate: 0,
            compound: false,
            dish_tax: children,
            tax_indicator_flag: false,
            tax_indicator_character: "*",
            tax_indicator_string: "* indicates a TAX free item.",
        });
        this.props.onChange(taxes);
    };
    copy(i) {
        const taxes = [...this.props.taxes];
        const tax = { ...taxes[i] };
        taxes.push(tax);
        this.props.onChange(taxes);
    }
    remove(i) {
        const taxes = ([...this.props.taxes]);
        taxes.splice(i, 1);
        this.props.onChange(taxes);
    }
    change(i, key, value) {
        const taxes = [...this.props.taxes];
        taxes[i][key] = key === "rate" ? Number(value) || 0 : value;
        this.props.onChange(taxes);
    }
    render() {
        return (React.createElement("div", { style: { width: '100%' } },
            React.createElement(SettingsFormGroupInput, { style: { marginBottom: 8 } },
                React.createElement(SettingsFormLabelContainer, null,
                    React.createElement(SettingsFormLabelLeftContainer, null, "Sales Taxes"),
                    React.createElement(SettingsFormLabelRightContainer, null,
                        React.createElement(SalesTaxesAddButton, { type: 'button', onClick: this.add },
                            React.createElement(IconPlusRed, null),
                            " Add")))),
            this.props.taxes && this.props.taxes.map((item, i) => {
                return (React.createElement(SalesTaxCard, { key: i },
                    React.createElement("div", { style: { display: 'flex', justifyContent: 'end', width: '100%' }, onClick: () => this.remove(i) },
                        React.createElement(TrashIcon, null)),
                    React.createElement(SettingsFormGroup, null,
                        React.createElement(SettingsFormGroupInput, null,
                            React.createElement(SettingsFormLabelContainer, null,
                                React.createElement(SettingsFormLabelLeftContainer, null, "Name")),
                            React.createElement(SettingsFormInputContainer, null,
                                React.createElement("input", { className: "no-round", required: true, value: item.name, onChange: (e) => this.change(i, "name", e.target.value) }))),
                        React.createElement(SettingsFormGroupInput, null,
                            React.createElement(SettingsFormLabelContainer, null,
                                React.createElement(SettingsFormLabelLeftContainer, null, "Rate(%)")),
                            React.createElement(SettingsFormInputContainer, null,
                                React.createElement("input", { type: "number", required: true, className: "no-round", value: item.rate, step: "0.001", onChange: (v) => this.change(i, "rate", v.target.value) }))),
                        React.createElement(SettingsFormGroupInput, { className: "flex-full" },
                            React.createElement(SettingsFormLabelContainer, null,
                                React.createElement(SettingsFormLabelLeftContainer, { style: { alignItems: 'center' } },
                                    React.createElement(Checkbox, { id: `${i}-tax-compound`, checked: item.compound, onChange: (e) => this.change(i, "compound", e.target.checked) }),
                                    "Compound"))),
                        React.createElement(SettingsFormGroupInput, null,
                            React.createElement(SettingsFormLabelContainer, null,
                                React.createElement(SettingsFormLabelLeftContainer, null, "Symbol")),
                            React.createElement(SettingsFormInputContainer, null,
                                React.createElement("input", { required: item.tax_indicator_flag === true, maxLength: 1, value: item.tax_indicator_character, onChange: (e) => this.change(i, "tax_indicator_character", e.target.value) }))),
                        React.createElement(SettingsFormGroupInput, null,
                            React.createElement(SettingsFormLabelContainer, null,
                                React.createElement(SettingsFormLabelLeftContainer, null, "Message")),
                            React.createElement(SettingsFormInputContainer, null,
                                React.createElement("input", { type: "string", required: item.tax_indicator_flag === true, className: "no-round", value: item.tax_indicator_string, onChange: (e) => this.change(i, "tax_indicator_string", e.target.value) }))),
                        React.createElement(SettingsFormGroupInput, { className: "flex-full" },
                            React.createElement(SettingsFormLabelContainer, null,
                                React.createElement(SettingsFormLabelLeftContainer, { style: { alignItems: 'center' } },
                                    React.createElement(Checkbox, { id: `${i}-tax-indicator`, checked: item.tax_indicator_flag, onChange: (e) => this.change(i, "tax_indicator_flag", e.target.checked) }),
                                    "Show Message"))),
                        React.createElement(SettingsFormGroupInput, null,
                            React.createElement(SettingsFormLabelContainer, null,
                                React.createElement(SettingsFormLabelLeftContainer, { style: { alignItems: 'center' } }, "Eligible Items")),
                            React.createElement(EligibleItemsContainer, null,
                                React.createElement(FormTreeSelect, { id: `dish_tax`, selected: item.dish_tax || [], nodes: this.props.treeData, onChange: (values) => {
                                        this.change(i, "dish_tax", values);
                                    } }))))));
            })));
    }
}
//# sourceMappingURL=index.js.map